export function anticipate(data) {
  // const NovaDivt = {}; // Falta definir essa função
  console.log(data)

  const payment_date = data.payment_date //Data de Pagamento
    ? data.payment_date
    : new Date().toISOString().split("T")[0];

  let due_date, //data de vencimento
    value, //Valor da Parcela
    description, //Descrição das Parcelas
    idSale, // ID do Contrato
    anticipateValue, // Valor da Parcela Antecipado
    late_interest,
    late_fee,
    change_month_anticipation;

  due_date = data.due_date;
  value = parseFloat(data.value);
  description = data.description;
  // eslint-disable-next-line no-unused-vars
  idSale = data.id_sale;
  change_month_anticipation = data.change_month_anticipation; // true é Mensal - false é Diário
  late_interest = parseFloat(data.late_interest); //Juros diario
  late_fee = parseFloat(data.late_fee); //Multa

  // console.log(data.change_month_anticipation);

  let lack; // Carência
  let firstDate; // Data da Primeira do Financiamento/Intermediaria
  firstDate = data.date_first_installment;

  if (firstDate) {
    lack = new Date(firstDate) - new Date(payment_date);
  } else {
    lack = 0;
  }

  const setStart = lack > 0 ? firstDate : payment_date;
  const definedEnd_formatted = new Date(due_date).toISOString().split("T")[0];
  const definedEnd = definedEnd_formatted;

  const difference = new Date(definedEnd) - new Date(setStart);

  let divt;
  if (difference >= 0) {
    if (
      (data.amortization_system === "sac" ||
        data.amortization_system === "sac_inverso" ||
        data.amortization_system === "sacoc" ||
        data.amortization_system === "sacreib" ||
        data.amortization_system === "sacre") &&
      description === "Parcela Financiamento"
    ) {
      const plano = data.number_financing_installments;
      const valor_para_parcelamento = data.financing_value;
      anticipateValue = valor_para_parcelamento / plano;
    } else {
      if (
        description === "Parcela Financiamento" ||
        description === "Parcela Intermediaria"
      ) {
        if (change_month_anticipation !== false) {
          divt = data.position;
        } else {
          const dtp = new Date(setStart).toISOString().split("T")[0];
          const dvp = new Date(due_date).toISOString().split("T")[0];
          divt = getBusinessDays(dtp, dvp) / 30;
        }

        let juros;
        juros = parseFloat(data.rate) / 100 + 1;

        const potencia = Math.pow(juros, divt);
        anticipateValue = value / potencia;
      } else {
        anticipateValue = value;
      }

      if (difference === 0) {
        anticipateValue = value;
      }
    }
  } else {
    let payment_date_delay = new Date(payment_date);
    let definedEnd_delay = new Date(definedEnd);

    let differenceInTime =
      payment_date_delay.getTime() - definedEnd_delay.getTime();
    let differenceInDays = differenceInTime / (1000 * 3600 * 24);
    let fine = value * (late_fee / 100);
    let fees = value * (late_interest / 100) * differenceInDays;
    anticipateValue = value + fine + fees;
  }
  console.log("Anticipate Value:", anticipateValue);
  return anticipateValue;
}

function getBusinessDays(startDate, endDate, holidays = []) {
  const [startYear, startMonth, startDay] = startDate.split("-").map(Number);
  const [endYear, endMonth, endDay] = endDate.split("-").map(Number);
  const days =
    (endYear - startYear) * 360 +
    (endMonth - startMonth) * 30 +
    (endDay - startDay);

  return days;
}
